import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LoadingOverlay from '../../components/others/LoadingOverlay';
import { LayoutEpayco } from './layout/LayoutEpayco';

const EpaycoScreen = () => {
    const navigate = useNavigate();
    const { subscriptionPlan } = useParams();

    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const validateRegistration = async () => {
            try {
                setStatus('success');
                // const response = await fetch(`https://tu-api.com/validate/${token}`);

                // if (response.ok) {
                //     setStatus('success');
                // } else {
                //     setStatus('error');
                //     // setTimeout(() => navigate('/login'), 3000);
                // }
            } catch (error) {
                console.error("Error validando token:", error);
                setStatus('error');
            }
        };

        if (subscriptionPlan) {
            validateRegistration();
        }
    }, [subscriptionPlan, navigate]);

    if (status === 'loading') {
        return <LoadingOverlay
            isOpen={true}
            text={'Cargando...'}
        />
    }

    if (status === 'error') {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography color="error" variant="h6">
                    El enlace de registro no es válido o ha expirado.
                </Typography>
            </Box>
        );
    }

    return <LayoutEpayco subscriptionPlan={subscriptionPlan} />;
};

export default EpaycoScreen;